<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "licencas") {
            next({ name: "licenca-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "licencas") {
            this.$router.push({ name: "licenca-list" });
        }
    },
};
</script>